<script lang="ts">
  import ResponsiveImagePartial from '$components/common/partials/ResponsiveImagePartial/ResponsiveImagePartial.svelte';
  import type { AproposImageComponentProps } from './types';

  type $$Props = AproposImageComponentProps;

  export let entryId: AproposImageComponentProps['entryId'];
  export let responsiveImageConfig: AproposImageComponentProps['responsiveImageConfig'];
  export let customCssClass: AproposImageComponentProps['customCssClass'];
</script>

<div
  class="AproposImageComponent AproposImageComponent-{entryId}-box-properties {customCssClass}"
  data-entry-id={entryId}
>
  <ResponsiveImagePartial config={responsiveImageConfig} />
</div>
